/**
 * A ky `parseJson` that reads an empty body as `undefined`. Without it, `.json()` on a 204 (or any
 * empty response) throws, rejecting a request that succeeded. Needs ky >= 2.1.0, the first
 * version that hands empty bodies to `parseJson`.
 */
export const parseJsonAllowingEmpty = (text) => text === '' ? undefined : JSON.parse(text);
/** The necessary headers for sending a form-urlencoded request. */
export const formUrlEncodedHeaders = Object.freeze({
    'content-type': 'application/x-www-form-urlencoded',
});
